import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router'; // Correct import for Router
import { Title } from '@angular/platform-browser';
import { SidebarServiceService } from '../../services/sidebar-service.service';
import { AngularMaterialModule } from '../../angular-material.module';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  AuthService,
  LoginBrandingConfig,
} from '../../Login/login/auth.service';
import {
  DEFAULT_LOGIN_UI,
  getHostName,
  applyEnvironmentBranding,
  resolveLoginUiFromHost,
} from '../../config/login-ui-host.config';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [AngularMaterialModule, CommonModule, RouterModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'], // Corrected to styleUrls
})
export class NavbarComponent implements OnInit {
  profilepic = sessionStorage.getItem('profile_pic');
  username = sessionStorage.getItem('username');
  storageUrl = environment.storageUrl;
  baseUrl = environment.baseUrl;
  userID = sessionStorage.getItem('session_id');
  allUserprofileList: any;

  /** Logo path shown in the navbar — matches login page for the current host / API branding. */
  brandLogo = DEFAULT_LOGIN_UI.logoPath;
  brandAlt = `${DEFAULT_LOGIN_UI.brandName} logo`;
  /** Host-based default before API override; used as fallback if the primary logo fails to load. */
  private hostResolvedLogo = DEFAULT_LOGIN_UI.logoPath;

  constructor(
    public sidebarStateService: SidebarServiceService,
    private router: Router,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private titleService: Title,
  ) {
    const hostUi = resolveLoginUiFromHost();
    this.hostResolvedLogo = hostUi.logoPath;
    this.brandLogo = hostUi.logoPath;
    this.brandAlt = `${hostUi.brandName} logo`;
    applyEnvironmentBranding(this.titleService, hostUi);
  }

  ngOnInit(): void {
    this.loadNavbarBrandingFromApi();
    console.log('Profile Pic:', this.profilepic);
    this.fetchUserProfile();
  }

  toggleSidebar() {
    this.sidebarStateService.toggleSidebar();
  }

  logOut() {
    this.router.navigate(['/login']);
    sessionStorage.clear();
  }

  navigateToProfile() {
    // Navigate to profile page - adjust route as needed
    this.router.navigate(['/profile']);
  }

  navigateToSettings() {
    // Navigate to settings page - adjust route as needed
    this.router.navigate(['/settings']);
  }

  handleImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    if (img) {
      img.src = 'assets/Images/userLogo.png';
    }
  }

  handleBrandLogoError(_event: Event) {
    if (this.brandLogo !== this.hostResolvedLogo) {
      this.brandLogo = this.hostResolvedLogo;
      return;
    }
    if (this.brandLogo !== DEFAULT_LOGIN_UI.logoPath) {
      this.brandLogo = DEFAULT_LOGIN_UI.logoPath;
    }
  }

  private loadNavbarBrandingFromApi(): void {
    const host = getHostName();
    if (!host) {
      return;
    }
    this.authService.getLoginBranding({ domain_url: host }).subscribe({
      next: (res) => {
        const payload = this.extractNavbarBrandingPayload(res);
        if (!payload) {
          return;
        }
        if (payload.logoPath?.trim()) {
          this.brandLogo = payload.logoPath.trim();
        }
        if (payload.brandName?.trim()) {
          this.brandAlt = `${payload.brandName.trim()} logo`;
        }
      },
      error: () => {
        // Keep host-based logo when branding API is not reachable.
      },
    });
  }

  private extractNavbarBrandingPayload(res: unknown): LoginBrandingConfig | null {
    if (!res || typeof res !== 'object') {
      return null;
    }
    const response = res as Record<string, unknown>;
    const data = response['data'];
    if (data && typeof data === 'object') {
      return data as LoginBrandingConfig;
    }
    return response as LoginBrandingConfig;
  }

  get displayName(): string {
    const fn = (this.allUserprofileList?.first_name || '').trim();
    const ln = (this.allUserprofileList?.last_name || '').trim();
    const full = `${fn} ${ln}`.trim();
    return full || sessionStorage.getItem('full_name') || '';
  }

  get accountName(): string {
    return this.allUserprofileList?.account_name || sessionStorage.getItem('account_name') || '';
  }

  get userRole(): string {
    return (
      this.allUserprofileList?.role ||
      this.allUserprofileList?.role_name ||
      sessionStorage.getItem('role_name') ||
      ''
    );
  }

  fetchUserProfile() {
    if (!this.userID) {
      return;
    }
    const requestData = { user_id: this.userID };
    this.http
      .post(`${this.baseUrl}/fetch_user_profile`, requestData)
      .subscribe({
        next: (res: any) => {
          const payload = res?.data || res;
          this.allUserprofileList = payload;
        },
        error: (err: any) => {
          console.error('Error fetching user profile:', err);
        },
        complete: () => {},
      });
  }
}
